import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceHigh: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVoiceHigh"><Path d="M8.5 3H7V21H8.5V3Z" fill="currentColor"/><Path d="M17 5H15.5V19H17V5Z" fill="currentColor"/><Path d="M12.75 7H11.25V17H12.75V7Z" fill="currentColor"/><Path d="M4.5 9H3V15H4.5V9Z" fill="currentColor"/><Path d="M21 9H19.5V15H21V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceHigh;
